import { Plugins } from '@capacitor/core'
import React from 'react'
import ReactDOM from 'react-dom'
import './config/workbox'
import syncCodePush from './cordova/syncCodePush'
import InitialLoading from './InitialLoading'
const App = React.lazy(() => import(/* webpackPrefetch: true */ './LoadApplication'))
const { SplashScreen } = Plugins
console.info(`running version ${process.env.VERSION}`)

const correctedHref = location.href
    .replace('www.', '')
    .replace('http://', process.env.SKIP_HTTPS_REDIRECTS === 'true' ? 'http://' : 'https://')
if (location.href !== correctedHref) {
    location.href = correctedHref
}

const Root = (
    <React.Suspense fallback={<InitialLoading />}>
        <App />
    </React.Suspense>
)

ReactDOM.render(Root, document.getElementById('root'))

document.addEventListener('deviceready', () => {
    SplashScreen.hide()
    syncCodePush()
})
document.addEventListener('resume', function () {
    syncCodePush(true)
})
